<div class="body-wrapper primary-bg">
    <div class="body white-bg radius-m px-5">
        <div class="body-header pt-7">
            <div class="list-options pl-6">
                <div class="list-name">
                    <p class="primary-text content-l">List name :</p>
                    <p class="primary-text content-l bold-text">{{rulevarservice.viewIntel.list_name}}</p>
                </div>
                <div class="options" [ngClass]="selectedForDelete ? '':'permission-denied'" (click)="deleteClick()">
                    <img src="../../../assets/rule/delete.svg" class="icon-s delete-icon enable-action tooltip-enable" tooltip="Delete selected">
                    <p class="content-m selectable-text delete-text enable-action">Delete selected</p>
                </div>
                <div class="reset-button" (click)="refreshtable()" [ngClass]="showReset ? '' : 'permission-denied'">
                    <img class="tooltip-enable enable-action icon-s" tooltip="Reset" src="assets/rule/refresh-data.svg">
                    <p class="content-m selectable-text delete-text enable-action">Reset</p>
                </div>
            </div>
            <div class="pagination pr-8">
                <div class="body-top-col-2">
                    <div class="custom-search">
                        <img class="icon-s" src="assets/settings/search-small.svg">
                        <input type="search" placeholder="Type to search here"
                            [formControl]="rulevarservice.intelviewsearch" class="placeholders input-border input-m">
                    </div>
                </div>

                <div class="body-top-col-3">
                    <img class="icon-s" src="assets/rule/left-arrow.svg" (click)="paginationClick(-1)"
                        [ngClass]="rulevarservice.intelViewpagenumber | disableAction:this.rulevarservice.intelViewpagelength:-1">
                    <p class="primary-texts content-m">{{rulevarservice.intelViewpagenumber}} of {{this.rulevarservice.intelViewpagelength}}</p>
                    <img  class="icon-s"src="assets/rule/right-arrow.svg" (click)="paginationClick(1)"
                        [ngClass]="rulevarservice.intelViewpagenumber | disableAction:this.rulevarservice.intelViewpagelength:1">
                </div>

                <div class="body-top-col-4">
                    <ng-container *ngFor="let pagedat of rulevarservice.commonData.pagination | keyvalue">
                        <p class="pagination-items-per-page content-m my-5 primary-texts">{{pagedat.key}}</p>
                        <app-overlay-select  [formControl]="rulevarservice.intelViewitemperpage"
                            [data]="pagedat.value"  fontsize="input-m">
                        </app-overlay-select>
                    </ng-container>

                </div>
                
            </div>
        </div>
        <div class="table p-6 pt-0">
            <ng-container *ngIf="rulevarservice.intel_view_filtered?.length > 0 && !mat_spinner_List_state">
                <table>
                    <thead>
                        <tr>
                            <th>
                                <input [formControl]=selectAll type="checkbox" class="shadow-none border-none enable-action tooltip-enable" tooltip="Select all" [ngClass]="!rulevarservice.intel_view_filtered?.length ? 'permission-denied':''">
                            </th>
                            <ng-container *ngFor="let head of rulevarservice.intel_view?.fields">
                                <th>{{head.fieldName}}</th>
                            </ng-container>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody [formGroup]="selected">
                        <ng-container *ngIf="rulevarservice.intel_view_filtered">
                            <tr *ngFor="let row of rulevarservice.intel_view_filtered | custompagination :rulevarservice.intelViewpagenumber:rulevarservice.intelViewitemperpage.value" class="enable-action">
                                <td>
                                    <input type="checkbox" class="shadow-none border-none enable-action" [formControlName]="row.uniqueKey" >
                                </td>
                                <td *ngFor="let val of rulevarservice.intel_view.fields">
                                    {{row[val.fieldName]}}
                                </td>
                                <td #orgin class="options-td">
                                    <div class="options"> 
                                    <div class="create selectable-text enable-action"  (click)="openSourceMenu_click(menu,orgin)" >
                                        <img class="icon-s"  src="../../assets/widgets/more-options.svg"></div>
                                        <ng-template #menu>
                                        <div class="source-container-2 content-m primary-text white-bg dropdown-shadow" [ngStyle]="{'width':'fit-content','right':'2vw','position':'relative'}" >
                                            <ng-container *ngFor="let option of rulevarservice.intelViewOptions">
                                            <p (click)="intelOptionClick(option,row)" [ngStyle]="{'white-space':'nowrap'}"  class="m-0 enable-action">{{option.disp}}</p>
                                            </ng-container>
                                        </div>
                                        </ng-template>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </ng-container>
            <ng-container *ngIf="rulevarservice.intel_view_filtered?.length === 0">
                <div class="no-result-container my-10 content-l bolder">
                    <img src="/assets/rule/empty-data.svg">
                    <div class="no-result">
                      <p class="primary-text bold-text"> No Result</p>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="mat_spinner_List_state && ! rulevarservice.intel_view_filtered">
                <div class="body-bottom-spinner">
                    <mat-spinner class="spinner" diameter=20></mat-spinner>
                </div>
            </ng-container>
            
            
        </div>
        <div class="footer pr-8">
            <button [ngClass]="!showReset ? 'permission-denied' : '' " class="submit" (click)="submitClick()">Save</button>
            <button class="cancel" (click)="cancelClick()">Cancel</button>
        </div>
    </div>
</div>
